import { types } from "../action_types";

const INITIAL_STATE = {
  auditLogs: { docs: [], totalDocs: 0, totalPages: 0, currentPage: 1 },
  auditLogsLoading: false,
  auditLogStats: null,
  auditLogStatsLoading: false,
};

const AuditLogReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GetAuditLogsRequest:
      return { ...state, auditLogsLoading: true };
    case types.GetAuditLogsRequestSuccess:
      return { ...state, auditLogs: payload, auditLogsLoading: false };
    case types.GetAuditLogsRequestFailure:
      return { ...state, auditLogsLoading: false };

    case types.GetAuditLogStatsRequest:
      return { ...state, auditLogStatsLoading: true };
    case types.GetAuditLogStatsRequestSuccess:
      return { ...state, auditLogStats: payload, auditLogStatsLoading: false };
    case types.GetAuditLogStatsRequestFailure:
      return { ...state, auditLogStatsLoading: false };

    default:
      return state;
  }
};

export default AuditLogReducer;
